import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const TopographicMap = () => {
    const pdfFiles = [
        "/DATA/Cyclone/TopographicMap/Suco Contour Map_ABANI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ABAT OAN.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ABO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ACUBILITOHO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ACUMANO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ACUMAU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AFABUBO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AFACA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AFALOICAI I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AFALOICAI II.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AFALOICAI III.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AHIC.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AI-ASSA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AIDABALETEN.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AILEBERE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AILELO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AILILI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AINARO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AISIRIMOU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AITEAS.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AITEMUA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AITUHA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AITUTU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ALAUA CRAIC.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ALAUA LETEN.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ASULAU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ATABAE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ATADAME_MALABE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ATARA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ATELARI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ATU-ABEN.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ATUDARA I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ATUDARA II.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_AUBEON.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BABOI CRAIC.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BABULO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BADO HO_O I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BADO HO_O II.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BADURO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BAGUIA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BAHA MORI I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BAHA MORI II.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BAHALARAUAIN.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BAHATATA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BAHU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BAIRRO PITE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BALIBAR.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BALIBO VILA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BANAFI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BANDUDATO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BARIQUE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BATARA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BATUGADE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BATUMANU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BAURO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BEBOI LETEN.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BECO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BECORA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BELECASAC.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BELOI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BELULIK LETEN.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BEMORI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BENE-UFE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BERELEU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BEREMANA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BETANO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BETULAU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BIBILEO I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BIBILEO II.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BIDAU SANTANA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BOBOCASE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BOBOMETO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BUALALE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BUBUSUSO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BUCOLI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BUIBAU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BUILALE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_BURUMA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CACAVEM.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAIBADA I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAICASA I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAICASA II.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAICOLI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAICUA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAIMAUC.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAINLIU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAIRUI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAMEA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CAMENAÃA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CARAUBALO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CASABAUC.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CASSA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CATRAI LETEN.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CATRAI-CRAIC.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CLACUC.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COLIATE-LEOTELO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COLIMAU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COLMERA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COM.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COMORO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COSTA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COTABOT.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COTAMUTU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COTOLAU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_COWA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CRIBAS.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_CUNHA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DAISUA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DARE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DATO RUA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DATO TOLU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DATO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DAU UDO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DAUDERE.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DEBOS.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DEFA UASSI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DELECO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DEUDET.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DILOR.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DOTIC.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DUCURAI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_DUYUNG (SEREIA).pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_EDI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ERAULO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_ESTADO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_EUQUISI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FADABLOCO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FAHILEBO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FAHINEHAN.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FAHIRIA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FAHISOI I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FAHISOI II.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FATISI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FATU-BESI.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FATUBOLU.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FATUBOSA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FATUCAHI I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FATUCALO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_FATUHADA.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_GRICENFOR.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_KAMPUNG ALOR.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_MALURO I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_MOTAEL.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_RAIFUN I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_SABULI I.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_SANTA CRUZ.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_SUAI LORO.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_TIRILOLO II.pdf",
    //     "/DATA/Cyclone/TopographicMap/Suco Contour Map_TUTUALA II.pdf",
     ];

    return (
        <div style={{ height: "100vh", width: "100%", overflowY: "auto" }}>
            {pdfFiles.map((pdfPath, index) => (
                <div key={index} style={{ marginBottom: "20px" }}>
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                        <Viewer fileUrl={pdfPath} />
                    </Worker>
                </div>
            ))}
        </div>
    );
};

export default TopographicMap;